export const getUploadedFileType = file => {
  const fileType = file && file.type;
  const fileSubType = fileType ? fileType.split('/').pop() : '';

  return fileSubType;
};
